import React from 'react';

import { Box, xcss } from '@atlaskit/primitives';

import { useLegacySearchTheme } from '@atlassian/navigation-system/experimental/use-legacy-search-theme';
import { ProductSearchInputSkeletonInteractiveSSR } from '@atlassian/product-search-dialog/skeleton';

import { expValEquals } from '@confluence/feature-experiments';
import {
	NavigationSearchDialog,
	QuickFind,
	useQuickFindEnabled,
} from '@confluence/navigation-search-dialog';
import { CONTEXT_PATH } from '@confluence/named-routes/src';
import { useRenderServerPlaceholder } from '@confluence/ssr-utilities';

export const SearchBar = () => {
	const theme = useLegacySearchTheme();
	const [isQuickFindEnabled] = useQuickFindEnabled();
	const renderServerPlaceholder = useRenderServerPlaceholder();

	const renderSearchBar = () => {
		return renderServerPlaceholder ? (
			<ProductSearchInputSkeletonInteractiveSSR
				placeholder="Search"
				advancedSearchUrl={`${CONTEXT_PATH}/search`}
				shouldFillContainer
			/>
		) : (
			<NavigationSearchDialog shouldFillContainer theme={theme} />
		);
	};

	const renderQuickFind = () => {
		/**
		 * Note: The return value of expValEquals can be false when:
		 *  - The user is in the control group of the experiment, in this case
		 *    cohort === 'control' and an exposure is counted
		 *  - The user is not in the experiment, in this case cohort === null
		 * 	 	and an exposure is not counted
		 */
		return renderServerPlaceholder &&
			!expValEquals('confluence_quick_find_ssr', 'cohort', 'test') ? (
			<ProductSearchInputSkeletonInteractiveSSR
				placeholder="Search"
				advancedSearchUrl={`${CONTEXT_PATH}/search`}
				shouldFillContainer
			/>
		) : (
			<QuickFind />
		);
	};

	return (
		<Box xcss={[searchBarWrapper, isQuickFindEnabled && flexStyles]}>
			{isQuickFindEnabled ? renderQuickFind() : renderSearchBar()}
		</Box>
	);
};

const searchBarWrapper = xcss({
	position: 'relative',
	width: '100%',
	maxWidth: '780px',
});

const flexStyles = xcss({
	display: 'flex',
	alignItems: 'center',
});
